import React from "react";
import NodePorts from "./NodePorts";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Assignment } from "@material-ui/icons";

const HSM_COLOR = "#128C7E"; // teal WhatsApp — distingue el nodo WABA de los bubbles clásicos

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    maxWidth: 280,
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    background: HSM_COLOR,
    border: "1px solid rgba(255, 255, 255, 0.2)",
    color: "white",
    position: "relative",
    transition: "opacity 0.2s ease",
    "&:hover": { opacity: 0.9 },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nodeIcon: { fontSize: 20 },
  nodeLabel: { fontWeight: 600, fontSize: 14, color: "white" },
  nodeContent: {
    fontSize: 12,
    opacity: 0.9,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(0.75),
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: 4,
    maxHeight: 80,
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: `2px solid ${HSM_COLOR}`,
    borderRadius: "50%",
  },
}));

const HsmTemplateNode = ({ data, selected }) => {
  const classes = useStyles();
  const templateName = data?.templateName || "Sin plantilla seleccionada";

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        border: selected ? "2px solid rgba(255, 255, 255, 0.5)" : "1px solid rgba(255, 255, 255, 0.2)",
      }}
    >
      <NodePorts color="#888" />
      <Box className={classes.nodeHeader}>
        <Assignment className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Plantilla HSM</Typography>
      </Box>
      <Box className={classes.nodeContent}>{templateName}</Box>
    </Box>
  );
};

export default HsmTemplateNode;
